module.exports = __webpack_public_path__ + "static/img/GitHub.83eb3739.png";